<template>
  <div class="vendor-listing-section">
    <h5 class="heading"
								data-test="variantListingSectionHeading"
								id="variantListingSectionHeading">
      More Buying Options
    </h5>
    <!--Exclude feature: Check Vendor Availability-->

    <!--<div class="vendor-listing-wrapper">-->
    <!--<div class="vendor-listing-item p-3"-->
    <!--style="cursor: pointer"-->
    <!--:style="(getAvailableVendors && getAvailableVendors.length === 0)?'border: solid 2px #ed5d5d;':''"-->
    <!--&gt;-->
    <!--<div class="w-100"-->
    <!--@click.prevent="deliveryAddressPickerPopUp"-->
    <!--&gt;-->
    <!--<svg xmlns="http://www.w3.org/2000/svg"-->
    <!--xmlns:xlink="http://www.w3.org/1999/xlink"-->
    <!--version="1.1"-->
    <!--x="0px"-->
    <!--y="0px"-->
    <!--viewBox="0 0 1000 1000"-->
    <!--enable-background="new 0 0 1000 1000"-->
    <!--xml:space="preserve" style="&#10;-->
    <!--width: 16px;&#10;-->
    <!--height: 14px;&#10;"-->
    <!--&gt;-->
    <!--<g>-->
    <!--<path d="M739.1,109C675.3,45.2,590.3,10,500,10c-90.3,0-175.3,35.2-239.1,99c-63.9,63.9-99.1,148.8-99.1,239.1c0,46.2,9.2,91,27.3,133.2c17.4,47.3,79.9,186.9,286.7,475L500,990l24.2-33.7c206.9-288.1,269.3-427.6,286.7-475c18.1-42.2,27.3-87,27.3-133.2C838.2,257.8,803,172.9,739.1,109z M500,428.5c-59.3,0-107.3-48.1-107.3-107.3c0-59.3,48.1-107.3,107.3-107.3c59.3,0,107.3,48.1,107.3,107.3C607.3,380.5,559.3,428.5,500,428.5z"/>-->
    <!--</g>-->
    <!--</svg>-->
    <!--<div class=""-->
    <!--style="font-size: 0.9rem; display: inline-block"-->
    <!--v-if="getSelectedAddress"-->
    <!--&gt;-->
    <!--{{getSelectedAddress.firstName? 'Deliver to '+getSelectedAddress.firstName: 'Login to get delivery updates'}}...-->
    <!--</div>-->
    <!--<div class=""-->
    <!--style="margin-left: 18px"-->
    <!--&gt;-->
    <!--<p v-if="getSelectedAddress">-->
    <!--{{getSelectedAddress.addressLine1?getSelectedAddress.addressLine1+',': ''}}-->
    <!--{{getSelectedAddress.locality?getSelectedAddress.locality+',': ''}}-->
    <!--{{getSelectedAddress.pinCode?getSelectedAddress.pinCode: ''}}-->
    <!--</p>-->
    <!--</div>-->
    <!--&lt;!&ndash;<a href="#">More Details</a>&ndash;&gt;-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <!--Exclude feature: Check Vendor Availability-->
    <div class="vendor-listing-wrapper">
      <div
        class="vendor-listing-item"
        v-for="(vendor, index) in vendorsList"
        :key="index"
      >
        <div class="left-s">
          <div class="price"
															:data-test="'variantListingSectionProPrice'+index"
															:id="'variantListingSectionProPrice'+index">
            {{(vendor.promotional_prices &&
            vendor.promotional_prices.length > 0)?
            vendor.promotional_prices[0].promotion_applied_price:
            vendor.price | currencyConversion
            }}
          </div>
          <div class="soldby">
            <p :data-test="'variantListingSectionVendorNamePara'+index"
															:id="'variantListingSectionVendorNamePara'+index">
              Sold by:
              <span :data-test="'variantListingSectionVendorName'+index"
																				:id="'variantListingSectionVendorName'+index">
															{{vendor.vendor_name}}</span>
            </p>
          </div>
          <!--<a href="#">More Details</a>-->
        </div>
        <div class="right-s">
          <cart-action
            :is-add-to-cart="true"
            :is-buy-now="false"
            :pdp="true"
            :fav="true"
            :product="product"
            :vendor-id="vendor.vendor_id"
            v-if="vendor.available_stock && vendor.available_stock > 0"
          />
          <div v-else>
            <button type="button"
                    class="btn btn-sm blue-btn"
                    :disabled="true"
                    data-test="vendorListingSectionOutOfStockButton"
                    id="vendorListingSectionOutOfStockButton"
            >
              Out of Stock
            </button>
          </div>
        </div>
      </div>
      <div
        class="vendor-listing-item"
        v-if="vendorsList && vendorsList.length === 0"
								data-test="variantListingSectionNoVendor"
								id="variantListingSectionNoVendor"
      > No seller available in your location.</div>
    </div>
    <div
      class="vendor-listing-footer"
      v-if="vendors && vendors.length > 3"
    >
      <p data-test="variantListingSectionVendorLengthPara"
									id="variantListingSectionVendorLengthPara">
        <router-link to="/product_description/vendorListing"
																					data-test="variantListingSectionVendorLengthLink"
																					id="variantListingSectionVendorLengthLink">
          {{vendors.length}} offers
        </router-link>
        from
        <span data-test="variantListingSectionVendorPrice"
														id="variantListingSectionVendorPrice">
									{{vendors[0].price | currencyConversion}}</span>
      </p>
    </div>
    <return-policy-section
      :returnPolicy="product.product_details"
      v-if="product.product_details && product.product_details.returnable"
    />
  </div>
</template>

<script>
import CartAction from '@/components/actions/cart/CartAction'
import ReturnPolicySection from '@/components/pages/productDetails/sections/ReturnPolicySection'
import { mapGetters } from 'vuex'

export default {
	name: 'vendor-listing-section',
	props: {
		vendors: null,
		product: {}
	},
	data () {
		return {

		}
	},
	components: {
		CartAction,
		ReturnPolicySection
	},
	computed: {
		...mapGetters('user', ['getUserData', 'getSelectedAddress']),
		...mapGetters('productselected', ['getAvailableVendors']),
		vendorsList () {
			if (this.vendors && this.vendors.length > 3) {
				return this.vendors.slice(0, 3)
			}
			return this.vendors
		}
	},
	methods: {
		deliveryAddressPickerPopUp () {
			this.$emit('showDeliveryAddressPickerPopUp')
		}
	}
}
</script>

<style scoped>
#contextualIngressPtPin {
  width: 16px;
  height: 14px;
  float: left;
  background-image: url("../../../../assets/img/locationPicker.png");
  background-repeat: no-repeat;
  background-size: auto;
  background-position: center;
  margin-bottom: 1px;
  margin-right: 5px;
}
</style>
